import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=f152b7d4&scoped=true&"
import script from "./client-list.vue?vue&type=script&lang=js&"
export * from "./client-list.vue?vue&type=script&lang=js&"
import style0 from "./client-list.vue?vue&type=style&index=0&id=f152b7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f152b7d4",
  null
  
)

export default component.exports